import { Injectable } from "@angular/core";
import * as Sentry from '@sentry/angular';
import { firstValueFrom, Observable, Subject, Subscription } from "rxjs";
import { LocationRelatedAPIService } from "../../../../shared/services/API/LocationRelatedAPI.service";
import { LocationRelatedDTO } from "../models/LocationRelatedDTO";
import { LocationsService } from "./Locations.service";
import { MatDialog } from "@angular/material/dialog";
import { LocationDTO } from "../models/LocationDTO";
import { DataNamesDTO } from "../models/DataNamesDTO";
import { IGeoPosDataLocation } from "../../route-section/models/IDataLocation";
import { CitronellaActionsService } from "../../../../shared/services/ServiceCatalogEncapsulators/CitronellaActions.service";
import { LocationRelatedTicketPopupComponent } from "../components/3-panel-detail-locations/organisms/location-related/location-related-ticket-popup/location-related-ticket-popup.component";
import { environment } from "src/environments/environment";
import { GeneralLocationsDetailsPopUpComponent } from "../components/3-panel-detail-locations/organisms/location-popup-details/general-location-detail-popup/general-location-details-popup.component";

@Injectable({
  providedIn: "root",
})
export class LocationRelatedService{
  
  public isLoadingList: boolean = false;

  //para panel related details como popup
  public dialogDetailsRef: any = null;
  locationDTO: LocationDTO;
  keys: string[] = [];
  values: string[] = [];
  keyNames: DataNamesDTO[] = [];
  arrayMaster: any[] = [];
  images: string[] = [];

  //para ticket como popup
  public dialogTicketRef: any = null;

  location_details_subscription: Subscription;

  constructor(private locationRelatedService: LocationRelatedAPIService, 
    private locationService: LocationsService, 
    private dialog: MatDialog,
    private citronellaActionsService: CitronellaActionsService) {
  }

  openTicketPopup(locationRelated: LocationRelatedDTO): void {
    if (this.dialogTicketRef) {
      this.dialogTicketRef.close();
      this.dialogTicketRef = null;
    }
    this.dialogTicketRef = this.dialog.open(LocationRelatedTicketPopupComponent, {
      width: "40vw",
      height: "fit-content",
      autoFocus: false,
      restoreFocus: false,
      data: { 
        noOrder: locationRelated.noOrder, 
        identifier: locationRelated.identifierChild, 
        title: locationRelated.title, 
        description: locationRelated.description, 
        direction: locationRelated.direction, 
        reparationTime: locationRelated.reparationTime,
        warrantyTime: locationRelated.sWarrantyTime,
        background: locationRelated.statusByPriority,
        pinColorHex: locationRelated.pinColorHex,
      }
    });

    this.dialogTicketRef.afterClosed().subscribe(result => {
      if(!environment.production) console.log('cerrado');
      this.dialogTicketRef = null;
    });
      
  }

  openRelatedDetailsPopup( identifier: any) {
      this.isLoadingList = true;
      if (this.dialogDetailsRef) {
        this.dialogDetailsRef.close();
        this.dialogDetailsRef = null;
      }
      this.dialogDetailsRef = this.dialog.open(
        GeneralLocationsDetailsPopUpComponent,
        {
          maxWidth: "98vw",
          maxHeight: "92vh",
          autoFocus: false,
          restoreFocus: false,
          hasBackdrop: false,
          disableClose: true,
          data: {
            identifier: identifier,
            parentCoordX: "",
            parentCoordY: "",
            FlyToOnOpen: false,
            FlyToParentOnClose: false
          },
        }
      );
      //añade el z-index al contenedor del overlay para que esté debajo del nav
      const overlayContainer = document.querySelector(".cdk-overlay-container") as HTMLElement;
      if (overlayContainer) {
        overlayContainer.style.zIndex = "4";
      }

      this.dialogDetailsRef.afterClosed().subscribe((result) => {
        if(!environment.production) console.log("cerrado");
        this.dialogDetailsRef = null;
        if(this.location_details_subscription)
          this.location_details_subscription.unsubscribe();
        //quita el z-index del contenedor del overlay
        const overlayContainer = document.querySelector(".cdk-overlay-container") as HTMLElement;
        if (overlayContainer) {
          overlayContainer.style.removeProperty("z-index");
        }
        this.isLoadingList = false;
      });
      // this.location_details_subscription = this.locationService.getByIdentifier(identifier).subscribe(
      //   async (data: EstatusJSON) => {
      //     if (data.isSuccess == true) {
      //       var properties = data.result;
      //       if(!environment.production) console.log("related Data", properties);
      //       await this.setDetailsData(properties);
  
      //       this.dialogDetailsRef = this.dialog.open(GeneralLocationsDetailsPopUpComponent, {
      //         maxWidth: "98vw",
      //         maxHeight: "92vh",
      //         autoFocus: false,
      //         restoreFocus: false,
      //         hasBackdrop: false,
      //         disableClose: true,
      //         data: { 
      //           locationDTO: this.locationDTO, 
      //           keys: this.keys, 
      //           keyNames: this.keyNames, 
      //           values: this.values, 
      //           images: this.images
      //         }
      //       });
        
      //       this.dialogDetailsRef.afterClosed().subscribe(result => {
      //         if(!environment.production) console.log('cerrado');
      //         this.dialogDetailsRef = null;
      //         this.location_details_subscription.unsubscribe();
      //       });
      //       this.isLoadingList = false;
      //     }
      //   },
      //   (error) => {
      //     this.isLoadingList = false;
      //   }
      // );
    }

    async setDetailsData(properties: any) {
        this.locationDTO = {
          identifier: properties.identifier,
          description: properties.description,
          lastVoltaje: properties.lastVoltage,
          batteryPercent: properties.batteryPercent,
          gpsStatus: properties.lastGPSStatus,
          canLock: properties.canLock,
          subGroup: properties.subGroup,
          group: properties.group,
          lastUpdate: properties.lastUpdate == '0001-01-01T00:00:00' || properties.lastUpdate == null ? 'No disponible' : properties.lastUpdate,
          activeType: properties.Tipo,
          id: properties.id,
          statusVehiculo: properties.statusVehiculo,
          idLocationCategory: properties.idLocationCategory,
          locationCategory: properties.locationCategory,
          icon: properties.icon,
          panelIcon: properties.icon,
          cordsY: properties.cordsY,
          cordsX: properties.cordsX,
          alias: properties.alias,
          categoryStatus: properties.categoryStatus,
          idLocationCategoryStatus: properties.idLocationCategoryStatus ?? 0,

          guid: '',
          color: '',
          data: [],
          counts: 0,
          isFullyAvailable: true,

          statusFlags: properties.statusFlags ? properties.statusFlags : [],
          flagTypes: properties.flagTypes ? properties.flagTypes : [],
        }
    
        if(!environment.production) console.log("SETDATA", properties);
        this.arrayMaster = Object.entries(properties.data);
        this.keys = [];
        this.values = [];
        this.arrayMaster.forEach((element) => {
          var obe: IGeoPosDataLocation;
          obe = JSON.parse(JSON.stringify(element[1]));
          this.keys.push(obe.key);
          this.values.push(obe.value);
        });
    
        // Hacer ambas llamadas en paralelo
        const [keyNamesResult, imagesResult] = await Promise.all([
          firstValueFrom(this.locationService.getDataNames(this.keys)),
          firstValueFrom(this.citronellaActionsService.getLocationImages(this.locationDTO.identifier)),
        ]);
      
        // Procesar los resultados
        if (keyNamesResult.isSuccess) {
          this.keyNames = keyNamesResult.result;
        } else {
          Sentry.captureMessage('LocationRelatedService.setDetailsData: keyNamesResult isSuccess false', { level: 'warning', extra: { response: keyNamesResult } });
        }
        if (imagesResult.isSuccess && imagesResult.result != null) {
          this.images = imagesResult.result;
        } else {
          Sentry.captureMessage('LocationRelatedService.setDetailsData: imagesResult isSuccess false or null', { level: 'warning', extra: { response: imagesResult } });
        }
      }


  // ------------------ api  --------------
  GetAllByIdentifier (identifier: string, includeGeoJson: boolean) {
    return this.locationRelatedService.GetAllByIdentifier(identifier, includeGeoJson);
  }

  GetRelatedFilteredByIdentifier (parentIdentifier: string, identifier: string, includeGeoJson: boolean) {
    return this.locationRelatedService.GetRelatedFilteredByIdentifier(parentIdentifier, identifier, includeGeoJson);
  }

  UpdateLocationRelatedOrder(locationRelatedList : LocationRelatedDTO[], identifier : string) {
    return this.locationRelatedService.UpdateLocationRelatedOrder(locationRelatedList, identifier);
  }
}
